// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1df7c","questions":"styles_questions__1nwSX","footer":"styles_footer__2Gdu-"};